import { createEntrRuntime } from '@/transport/runtime';
import type { EntrRuntime } from '@/transport/types';
import type { UseKioskConfig } from './useKioskConfig';

export function createEntrRuntimeFromConfig(
  kioskConfig: UseKioskConfig
): EntrRuntime {
  return createEntrRuntime({
    resolvePrinterId: () => kioskConfig.printerName.value,
    resolvePrinterConfig: () =>
      kioskConfig.isReady.value ? kioskConfig.printerConfig.value : undefined,
    resolvePaymentDestination: () => kioskConfig.paymentDestination.value,
    resolveStripeAccountId: () => kioskConfig.stripeAccountId.value,
  });
}
